import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-killsheet-popup',
  templateUrl: './killsheet-popup.component.html',
  styleUrls: ['./killsheet-popup.component.scss']
})
export class KillsheetPopupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
